import { render, staticRenderFns } from "./NewMail.vue?vue&type=template&id=72595b3e"
import script from "./NewMail.vue?vue&type=script&lang=js"
export * from "./NewMail.vue?vue&type=script&lang=js"
import style0 from "./NewMail.vue?vue&type=style&index=0&id=72595b3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports